import { createMuiTheme, ThemeOptions } from '@material-ui/core';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';
import { Overrides } from '@material-ui/core/styles/overrides';
import shadows, { Shadows } from '@material-ui/core/styles/shadows';

const palette: PaletteOptions = {
  primary: { // purple
    main: 'rgba(65, 0, 153, 1.0)',
    light: 'rgba(65, 0, 153, 0.08)',
    dark: 'rgba(28, 0, 67, 1.0)',
    // contrastText: 'rgba(237, 224, 255, 1.0)',
  },
  secondary: { // blue
    main: 'rgba(0, 101, 207, 1.0)',
    light: 'rgba(0, 101, 207, .08)',
    dark: 'rgba(0, 49, 101, 1.0)',
    // contrastText: 'rgba(232, 243, 255, 1.0)',
  },
  info: { // light blue
    main: 'rgba(60, 170, 190, 1.0)',
    light: 'rgba(60, 170, 190, 0.5)',
    dark: 'rgba(0, 145, 175, 1.0)',
  },
  success: { // green
    main: 'rgba(104, 203, 66, 1.0)',
    light: 'rgba(104, 203, 66, 0.6)',
    dark: 'rgba(38, 124, 6, 1.0)',
  },
  error: { // red
    main: 'rgba(200 , 30, 30, 1.0)',
    light: 'rgba(200 , 30, 30, 0.5)',
    dark: 'rgba(150, 20, 20, 1.0)',
  },
  warning: { // yellow orange
    main: 'rgba(222, 154, 46, 1.0)',
    light: 'rgba(222, 154, 46, 1.0)',
    dark: 'rgba(173, 102, 4, 1.0)',
  },
  text: { // black
    primary: 'rgba(0, 0, 0, 1.0)',
    secondary: 'rgba(0, 0, 0, 0.7)',
    disabled: 'rgba(234, 234, 234, 1.0)',
  },
  action: { // purple
    active: 'rgba(0, 0, 0, 1.0)',
    hover: 'rgba(65, 0, 153, 0.75)',
    selected: 'rgba(65, 0, 153, 1.0)',
    disabled: 'rgba(65, 0, 153, 0.3)',
    disabledBackground: 'rgba(65, 0, 153, 0.3)',
  },
  background: { // white
    default: 'rgba(255, 255, 255, 1.0)',
    paper: 'rgba(255, 255, 255, 1.0)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  tonalOffset: 0.2,
  contrastThreshold: 3,
};

const typography: TypographyOptions = {
  fontFamily: [
    'Roboto',
    'sans-serif',
  ].join(','),
  fontSize: 12,
};

const overrides: Overrides = {
  MuiCssBaseline: {
    '@global': {
      html: {
        WebkitFontSmoothing: 'auto',
      },
    },
  },
};

const defaultTheme: ThemeOptions = createMuiTheme({
  palette,
  typography,
  overrides,
  shadows: shadows.map(() => 'none') as Shadows,
});

export default defaultTheme;
